import type { CodeBrand } from '@/config/codeBrand';

/** localStorage for Q7.4 — LBS: like-most; Dice: mention likelihood (final step). */
export const Q7_4_STORAGE_KEY = 'npdsurvey:q7_4';

export const Q7_4_OPTIONS_LBS = [
  'Taste/flavour',
  'Overall experience',
  'Appearance/pack',
  'Something different from my usual choice',
  'Nothing in particular',
] as const;

export const Q7_4_OPTIONS_DICE = [
  'Very likely',
  'Somewhat likely',
  'Not very likely',
  'Not at all likely',
  'Not sure',
] as const;

/** @deprecated Prefer brand-specific lists via `getQ7_4Options`. */
export const Q7_4_OPTIONS = Q7_4_OPTIONS_LBS;

export type Q7_4OptionLbs = (typeof Q7_4_OPTIONS_LBS)[number];
export type Q7_4OptionDice = (typeof Q7_4_OPTIONS_DICE)[number];
export type Q7_4Option = Q7_4OptionLbs | Q7_4OptionDice;

export type Q7_4Answers = {
  selected: Q7_4Option;
};

export function getQ7_4Options(brand: CodeBrand | null | undefined): readonly Q7_4Option[] {
  return brand === 'Dice' ? Q7_4_OPTIONS_DICE : Q7_4_OPTIONS_LBS;
}

function isQ7_4Option(v: unknown): v is Q7_4Option {
  return (
    typeof v === 'string' &&
    ((Q7_4_OPTIONS_LBS as readonly string[]).includes(v) ||
      (Q7_4_OPTIONS_DICE as readonly string[]).includes(v))
  );
}

export function readQ7_4Answers(): Q7_4Answers | null {
  try {
    const raw = localStorage.getItem(Q7_4_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const selected = (o as { selected?: unknown }).selected;
    if (isQ7_4Option(selected)) {
      return { selected };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeQ7_4Answers(data: Q7_4Answers): void {
  try {
    localStorage.setItem(Q7_4_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_4Answers(): void {
  try {
    localStorage.removeItem(Q7_4_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_4Complete(): boolean {
  return readQ7_4Answers() != null;
}

/** Alias used by later survey gates / submit. */
export function getEffectiveQ7_4Answers(): Q7_4Answers | null {
  return readQ7_4Answers();
}

export function isQ7_4CompleteForSurvey(): boolean {
  return isQ7_4Complete();
}
